import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=4b346fe2&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b346fe2",
  null
  
)

export default component.exports